<template>
  <action-log-template :actionLog="actionLog">
    <template #actionName>
      <p :class="['action-type flex-row flex__left inline-flex']">
        <i
          :class="['font-size__small', 'fal fa-check-circle', 'color__blue']"
        ></i>
        <span class="font-size__small no_wrap color__blue">
          &nbsp;{{ actionNameLabel || "-" }}
        </span>
        &nbsp;
        <value-change-logs-detail
          :valueChangeLogs="valueChangeLogs"
          @showChangeLogs="showChangeLogs"
        ></value-change-logs-detail>
      </p>
    </template>
  </action-log-template>
</template>

<script>
import convertToLabelFilter from "../../../filters/convertToLabelFilter";
import hcCVTTBaoCaoChangeLogsBuilder from "../../../services/hanhchinh/congviectrongtam/hcCVTTBaoCaoChangeLogsBuilder";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import h from "../../../services/h";
import utils from "../../../services/utils";
import ActionLogTemplate from "../ketluan/action-log-template";
import constants from "../../../constants";
import ValueChangeLogsDetail from "../ketluan/value-change-logs-detail";
import categoryViewService from "../../../services/categoryViewService";

export default {
  name: "hc-cong-viec-trong-tam-common-update-action-log",
  components: { ValueChangeLogsDetail, ActionLogTemplate },
  props: ["actionLog", "hcCaseCommandsId"],
  filters: {
    convertToLabelFilter
  },
  data() {
    return {
      actionNameLabel: null,
      dataJson: null,
      oldHcCommon: null,
      newHcCommon: null,
      hcList: null,
      oldHcList: null,
      oldDirectiveActor: null,
      oldPerformActor: null,
      directiveActor: null,
      performActor: null,
      thucHienDepartments: null,
      oldThucHienDepartments: null,
      newDeadline: null,
      oldDeadline: null,
      valueChangeLogs: [],
      hcDocRelations: null,
      oldHcDocRelations: null,
      isPopulatedValueChangeLogs: false,
      sectorCategories: null
    };
  },

  // watch: {
  //   hcCaseCommandsId() {
  //     this.isPopulatedValueChangeLogs = false;
  //     this.valueChangeLogs = [];
  //   }
  // },

  created() {
    this.actionNameLabel = hanhChinhUtils.getActionLogActionNameLabel(
      this.actionLog.actionName
    );
    this.dataJson = JSON.parse(this.actionLog.dataJson);
  },

  methods: {
    async showChangeLogs() {
      if (!this.isPopulatedValueChangeLogs) {
        this.sectorCategories = await categoryViewService
          .findAllByGroupCode(constants.CATEGORY_GROUP_CODE.HC_COMMAND_SECTOR)
          .then(response => response.data);
        this.populateValueChangeLogs();
        await this.populateBaoCaoChangeLogs();
        this.isPopulatedValueChangeLogs = true;
      }
    },

    formatDate(value) {
      return hanhChinhUtils.formatDate(value);
    },

    getDisplayProperty(property) {
      switch (property) {
        case "meeting":
          return "Tiêu đề";
        case "commandsDate":
          return "Ngày chỉ đạo";
        case "deadline":
          return "Hạn xử lý";
        case "conclusion":
          return "Nội dung công việc";
        case "performId":
          return "Lãnh đạo phụ trách";
        case "directionContent":
          return "Ý kiến chỉ đạo";
        case "note":
          return "Ghi chú";
        case "chuTriDepts":
          return "Đơn vị chủ trì";
        case "hcDocRelations":
          return "Văn bản liên quan";
        default:
          return "-";
      }
    },

    populateBaoCaoChangeLogs() {
        return this.dataJson.hcCongViecTrongTamBaoCaoActionLog
        ? hcCVTTBaoCaoChangeLogsBuilder
            .newInstance()
            .build(this.dataJson.hcCongViecTrongTamBaoCaoActionLog)
            .then(({ valueChangeLogs }) =>
              this.valueChangeLogs.push(...valueChangeLogs)
            )
        : Promise.resolve();     
    },

    populateValueChangeLogs() {
      this.oldHcCommon = this.dataJson.oldHcCongViecTrongTamCommon;
      this.newHcCommon = this.dataJson.newHcCongViecTrongTamCommon;
      this.hcList = this.dataJson.hcCongViecTrongTamList;
      this.oldHcList = this.dataJson.oldHcCongViecTrongTamList;
      this.oldDirectiveActor = this.dataJson.oldDirectiveActor;
      this.oldPerformActor = this.dataJson.oldPerformActor;
      this.directiveActor = this.dataJson.directiveActor;
      this.performActor = this.dataJson.performActor;
      this.thucHienDepartments = this.dataJson.thucHienDepartments;
      this.oldThucHienDepartments = this.dataJson.oldThucHienDepartments;
      this.newDeadline = this.dataJson.newDeadline;
      this.oldDeadline = this.dataJson.oldDeadline;
      this.hcDocRelations = this.dataJson.hcDocRelations || [];
      this.oldHcDocRelations = this.dataJson.oldHcDocRelations || [];

      h.each(
        [
          "meeting",
          "commandsDate",
          "deadline",
          "conclusion",
          "performId",
          "directionContent",
          "note",
          "chuTriDepts",
          "hcDocRelations"
        ],
        property => {
          let oldValue;
          let newValue;
          switch (property) {
            case "deadline":
              if (this.oldDeadline !== this.newDeadline) {
                return this.valueChangeLogs.push({
                  property: property,
                  propertyLabel: this.getDisplayProperty(property),
                  oldValue: this.formatDate(this.oldDeadline),
                  newValue: this.formatDate(this.newDeadline)
                });
              }
              break;
            case "performId":
              this.populateValueChangeLogsForActor(property);
              break;
            case "chuTriDepts":
              this.populateValueChangeLogsForThucHienDepts(property);
              break;
            case "hcDocRelations":
              this.populateValueChangeLogsForHcDocRelations(property);
              break;
            case "sector":
              oldValue = this.oldHcCommon[property];
              newValue = this.newHcCommon[property];
              if (oldValue !== newValue) {
                return this.valueChangeLogs.push({
                  property: property,
                  propertyLabel: this.getDisplayProperty(property),
                  oldValue: hanhChinhUtils.getHcCommandSectorName(
                    oldValue,
                    this.sectorCategories
                  ),
                  newValue: hanhChinhUtils.getHcCommandSectorName(
                    newValue,
                    this.sectorCategories
                  )
                });
              }
              break;
            case "commandsDate":
              oldValue = this.formatDate(
                this.oldHcCommon[property]
              );
              newValue = this.formatDate(
                this.newHcCommon[property]
              );
              if (oldValue !== newValue) {
                return this.valueChangeLogs.push({
                  property: property,
                  propertyLabel: this.getDisplayProperty(property),
                  oldValue: oldValue,
                  newValue: newValue
                });
              }
              break;
            default:
              oldValue = this.oldHcCommon[property];
              newValue = this.newHcCommon[property];
              if (oldValue !== newValue) {
                return this.valueChangeLogs.push({
                  property: property,
                  propertyLabel: this.getDisplayProperty(property),
                  oldValue: oldValue,
                  newValue: newValue
                });
              }
              break;
          }
        }
      );
    },

    populateValueChangeLogsForThucHienDepts(property) {
      let processType;
      switch (property) {
        case "chuTriDepts":
          processType = constants.HC_CASE_COMMANDS.PROCESS_TYPE.CHU_TRI;
          break;
        case "phoiHopDepts":
          processType = constants.HC_CASE_COMMANDS.PROCESS_TYPE.PHOI_HOP;
          break;
      }

      let oldDepartments = h.findAll(this.oldThucHienDepartments, dept =>
        h.exists(
          this.oldHcList,
          hc =>
            hc.deptId === dept.id &&
            hc.processType === processType
        )
      );

      let departments = h.findAll(this.thucHienDepartments, dept =>
        h.exists(
          this.hcList,
          hc =>
            hc.deptId === dept.id &&
            hc.processType === processType
        )
      );

      let oldValue = (h.collect(oldDepartments, dept => dept.deptName) || [])
        .join("\n")
        .trim();

      let newValue = (h.collect(departments, dept => dept.deptName) || [])
        .join("\n")
        .trim();

      if (oldValue !== newValue) {
        this.valueChangeLogs.push({
          property: property,
          propertyLabel: this.getDisplayProperty(property),
          oldValue: oldValue,
          newValue: newValue
        });
      }
    },

    populateValueChangeLogsForActor(property) {
      let oldId;
      let newId;
      let oldActor;
      let newActor;
      switch (property) {
        case "directiveId":
          oldId = this.oldDirectiveActor ? this.oldDirectiveActor.id : null;
          newId = this.directiveActor ? this.directiveActor.id : null;
          oldActor = this.oldDirectiveActor;
          newActor = this.directiveActor;
          break;
        case "performId":
          oldId = this.oldPerformActor ? this.oldPerformActor.id : null;
          newId = this.performActor ? this.performActor.id : null;
          oldActor = this.oldPerformActor;
          newActor = this.performActor;
          break;
      }
      if (oldId !== newId) {
        this.valueChangeLogs.push({
          property: property,
          propertyLabel: this.getDisplayProperty(property),
          oldValue: utils.buildUserDeptRoleViewLabel(oldActor),
          newValue: utils.buildUserDeptRoleViewLabel(newActor)
        });
      }
    },

    populateValueChangeLogsForHcDocRelations(property) {
      hanhChinhUtils.populateValueChangeLogsForHcDocRelations(
        property,
        this.oldHcDocRelations,
        this.hcDocRelations,
        this.valueChangeLogs,
        this.getDisplayProperty(property)
      );
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/congviectrongtam/hc-congviectrongtam-common-update-action-log.vue